import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { CreateProjectPayload, UpdateProjectPayload } from './projectTypes';

// Create Project with file upload (FormData)
export const createProject = createAsyncThunk(
  'projects/createProject',
  async (data: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('project_name', data.project_name);
      formData.append('client_id', String(data.client_id));
      formData.append('total_hours', data.total_hours);
      formData.append('start_date', data.start_date);
      formData.append('end_date', data.end_date);
      formData.append('priority', data.priority);
      formData.append('project_value', data.project_value);
      formData.append('price_type', data.price_type);
      formData.append('description', data.description);
      formData.append('created_by', data.created_by);
      formData.append('project_progress', data.project_progress);
      formData.append('status', data.status);

    //   if (data.project_logo) formData.append('project_logo', data.project_logo);
      if (data.project_doc) formData.append('project_doc', data.project_doc);
      const response = await employeeServiceApiInstance.post('/projects', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create project');
    }
  }
);

// Update Project with file upload (FormData)
export const updateProject = createAsyncThunk(
  'projects/updateProject',
  async ({ projectId, ...data }: any & { projectId: number }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      if (data.project_name) formData.append('project_name', data.project_name);
      if (data.client_id) formData.append('client_id', String(data.client_id));
      if (data.total_hours) formData.append('total_hours', data.total_hours);
      if (data.start_date) formData.append('start_date', data.start_date);
      if (data.end_date) formData.append('end_date', data.end_date);
      if (data.priority) formData.append('priority', data.priority);
      if (data.project_value) formData.append('project_value', data.project_value);
      if (data.price_type) formData.append('price_type', data.price_type);
      if (data.description) formData.append('description', data.description);
      if (data.project_progress) formData.append('project_progress', data.project_progress);
      if (data.status) formData.append('status', data.status);
      formData.append('modified_by', data.modified_by);

      if (data.project_logo) formData.append('project_logo', data.project_logo);
      if (data.project_doc) formData.append('project_doc', data.project_doc);

      const response = await employeeServiceApiInstance.put(`/projects/${projectId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update project');
    }
  }
);

// Delete Project
export const deleteProject = createAsyncThunk(
  'projects/deleteProject',
  async ({ projectId }: { projectId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/projects/${projectId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete project');
    }
  }
);

// Fetch Project by ID
export const fetchProjectById = createAsyncThunk(
  'projects/fetchProjectById',
  async ({ projectId }: { projectId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/projects/${projectId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch project');
    }
  }
);

// Fetch All Projects
export const fetchAllProjects = createAsyncThunk(
  'projects/fetchAllProjects',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/projects');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch projects');
    }
  }
);

// Fetch Project by EmployeeId
export const fetchProjectByEmployeeId = createAsyncThunk(
    'projects/fetchProjectByEmployeeId',
    async ({ employeeId }: { employeeId: number }, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/projects/employee/${employeeId}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch project');
      }
    }
  );
export const fetchProjectByDetails = createAsyncThunk(
    'projects/fetchProjectByDetails',
    async ({ projectId }: { projectId: any }, { rejectWithValue }) => {
      try {
        
        const response = await employeeServiceApiInstance.get(`/project/admindashboard/${projectId}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch project');
      }
    }
  );
